export default "__VITE_ASSET__b79d9f92__"